import React, { useContext, useState } from "react";
import { ErrorBoundary } from "react-error-boundary";
import { applyLocationAttrs } from "./OtelSpan.js";
import { TraceContext } from "./TraceProvider.js";
const reactPrefix = "react";
const ReactComponentAttributes = {
  REACT_COMPONENT: `${reactPrefix}.component`,
  REACT_COMPONENT_STACK: `${reactPrefix}.stack`,
  REACT_COMPONENT_ERROR: `${reactPrefix}.error`
};
const withTraceErrorBoundary = (WrappedComponent, ErrorDetailsComponent) => (props) => {
  const { tracingService } = useContext(TraceContext);
  const [errorState, setErrorState] = useState({ error: null, info: { componentStack: "" } });
  function applyComponentAttrs(span, component, stack, error) {
    span?.setAttributes({
      [ReactComponentAttributes.REACT_COMPONENT]: component,
      [ReactComponentAttributes.REACT_COMPONENT_STACK]: stack,
      [ReactComponentAttributes.REACT_COMPONENT_ERROR]: error?.message
    });
  }
  function handleError(error, info) {
    setErrorState({ error, info });
    console.dir(error);
    console.dir(info);
    const tracer = tracingService.getTracer();
    tracer.startActiveSpan("REACT COMPONENT", (span) => {
      const lengthLimit = 500;
      const shortStack = info.componentStack?.length > lengthLimit ? info.componentStack?.substring(0, lengthLimit) : info.componentStack;
      applyLocationAttrs(span);
      applyComponentAttrs(span, WrappedComponent?.displayName ?? WrappedComponent?.name, shortStack, error);
      tracingService.endSpanFailed(span, `${error?.message} ${shortStack}`);
    });
  }
  function renderFallback() {
    return /* @__PURE__ */ React.createElement(ErrorDetailsComponent, { error: errorState?.error, componentStack: errorState?.info.componentStack });
  }
  return /* @__PURE__ */ React.createElement(ErrorBoundary, { onError: handleError, fallbackRender: renderFallback }, /* @__PURE__ */ React.createElement(WrappedComponent, { ...props }));
};
export {
  withTraceErrorBoundary
};
//# sourceMappingURL=TraceErrorBoundary.js.map
